import { LinkTo } from 'shared/constants/linkTo';

/** URL страницы общего поиска (для кнопки/ссылки перехода). Если передан search — добавляет ?search= */
export const getFindProjectsPageUrl = (search?: string): string =>
  search?.trim()
    ? `${LinkTo.findProjects}?search=${encodeURIComponent(search.trim())}`
    : LinkTo.findProjects;
import { LinkTo } from 'shared/constants/linkTo';

/** URL страницы общего поиска (для кнопки/ссылки перехода). Если передан search — добавляет ?search= */
export const getFindProjectsPageUrl = (search?: string): string =>
  search?.trim()
    ? `${LinkTo.findProjects}?search=${encodeURIComponent(search.trim())}`
    : LinkTo.findProjects;
